const pad0 = x => x.toString().padStart(2, "0");

const JSONClone = ob => {
    return JSON.parse(JSON.stringify(ob))
}

// set the focus on specific control
const setFocusTo = (element_id, immediate = false) => {
    if (element_id) {
        setTimeout(function () {
            let element = document.getElementById(element_id);
            if (element) element.focus();
        }, immediate ? 1 : 280);
    }
}

const scrollToElement = (element_id, timeout = 10) => {
    setTimeout(function () {
        let element = document.getElementById(element_id);
        if (element) {
            element.scrollIntoView();
        }
    }, 10);
}

const upCaseStr = (str) => {
    let letters = [
        [ 'Ά', 'Α' ],
        [ 'Έ', 'Ε' ],
        [ 'Ή', 'Η' ],
        [ 'Ί', 'Ι' ],
        [ 'Ϊ', 'Ι' ],
        [ 'Ό', 'Ο' ],
        [ 'Ύ', 'Υ' ],
        [ 'Ϋ', 'Υ' ],
        [ 'Ώ', 'Ω' ],
    ];

    str = str.toUpperCase();
    letters.map( letter => {
        str = str.replace(new RegExp(letter[0], 'g'), letter[1]);
    });
    return str;
}

const slugify = str => {
    const txt = str.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    const slug = txt.replace(/[^a-z0-9]+/g, '-');
    return slug.replace(/^-+|-+$/g, '');
}

const findNode = (id, array) => {
    let node = null;
    node = array.find(x => x.id == id);
    if (!node) {
        array.map(item => {
            if (!node && item.children.length) {
                node = findNode(id, item.children);
            }
        })
    }
    return node;
}

const searchNodes = (term, array) => {
    let results = [];

    array.map(item => {
        let name = '';
        if (item.name_el) {

            name = upCaseStr(item.name_el);
        } else {
            name = upCaseStr(item.name);
        }
        if (name.indexOf(term) > -1) {
            results.push(item.id);
        }

        if (item.children.length) {
            results = results.concat(searchNodes(term, item.children));
        }
    });

    return results;
}

const findUnmatched = (matches, array, search_level = 0) => {
    let results = [];

    array.map(item => {
        // find item matches
        if (parseInt(item.level) >= search_level) {
            let allowMatch = item?.match_not_allowed != 1;
            if (allowMatch) {
                let match = matches.find(x => x.match_id === item.id);
                if (!match) {
                    results.push(item.id);
                }
            }
        }
        if (item.children.length) {
            results = results.concat(findUnmatched(matches, item.children, search_level));
        }
    })

    return results;
}

// Find unmatched for estateweb locations
const findUnmatchedEw = (matches, array) => {
    let results = [];

    array.map(item => {
        // find item matches
        let match = matches.find(x => x.match_id === item.id);
        if (!match && (item.properties > 0 || item.requests > 0)) {
            results.push(item.id);
        }
        if (item.children.length) {
            results = results.concat(findUnmatchedEw(matches, item.children));
        }
    })

    return results;
}

const backPath = (id, array) => {
    let path = "";
    if (id > 0) {
        let node = findNode(id, array);
        while (node) {
            if (node.name_el) {
                path = node.name_el + (path ? "»" : "") + path;
            } else {
                path = node.name + (path ? "»" : "") + path;
            }
            if (node.parent_id > 0) {
                node = findNode(node.parent_id, array);
            } else {
                node = null;
            }
        }
    }

    return path;
}

const getParentNodes = (node, array) => {
    let parents = [];
    let parent = findNode(node.parent_id, array);
    while (parent) {
        parents.push(parent);
        if (parent.parent_id > 0) {
            parent = findNode(parent.parent_id, array);
        } else {
            parent = null;
        }
    }

    return parents;
}

const expandParents = (id, array) => {
    let node = findNode(id, array);
    if (!node) {
        return;
    }
    let parents = getParentNodes(node, array);
    parents.map(item => {
        item.expanded = true;
    });
}

const findNodeParentOfLevel = (id, level, array) => {
    let node = findNode(id, array);
    let found = false;
    while (!found && node) {
        if (node.level == level) {
            found = true;
        } else {
            node = findNode(node.parent_id, array);
        }
    }
    return node;
}

const collapseAll = (array, exclude_id = 0) => {
    array.map(item => {
        item.expanded = false;
        collapseAll(item.children);
    });
    if (exclude_id > 0) {
        expandParents(exclude_id, array);
    }
}

export {
    JSONClone,
    setFocusTo,
    scrollToElement,
    upCaseStr,
    slugify,
    findNode,
    searchNodes,
    findUnmatched,
    findUnmatchedEw,
    backPath,
    getParentNodes,
    expandParents,
    findNodeParentOfLevel,
    collapseAll,
};